/* This file contains utilities which uses Browser APIs */

/**
 * getValueFromStorage returns value from the browser's local storage based on the provided @key
 * It first checks if the @windowObj is provided, if not it returns null
 * Then it tries to get the value from local storage using the provided key
 * If the value does not exist, it returns null
 */
const getValueFromStorage = (key, windowObj) => {
    if (!windowObj) return null;

    const value = windowObj.localStorage.getItem(key);
    if (!value) return null;

    // decode b64 to original
    return JSON.parse(decodeURIComponent(decodeURI(atob(value))));
};

/**
 * setValueInStorage returns a function that sets a @value in the browser's local storage based on the provided @key
 * It first checks if the @windowObj is provided, if not it does nothing
 * Then it encodes the value in base64 and sets it in the local storage using the provided key
 */
const setValueInStorage = (key, value, windowObj) => {
    if (!windowObj) return;

    // encode in b64
    const encodedString = btoa(encodeURI(encodeURIComponent(JSON.stringify(value))));
    windowObj.localStorage.setItem(key, encodedString);
};

/**
 * removeValueFromStorage returns a function that removes a value from the browser's local storage based on the provided @key
 * It first checks if the @windowObj is provided, if not it does nothing
 * Then it removes the value from the local storage using the provided key
 */
const removeValueFromStorage = (key, windowObj) => {
    if (!windowObj) return;

    windowObj.localStorage.removeItem(key);
};

export { getValueFromStorage, setValueInStorage, removeValueFromStorage };
